import { createSelector } from '@ngrx/store';
import { getStorePageState } from '../store.selectors';

export const getStoreImagesState = createSelector(
  getStorePageState,
  (state) => state.imagesState
);
export const getStoreImagesIsLoading = createSelector(
  getStoreImagesState,
  (images) => images.isLoading
);
export const getStoreImagesData = createSelector(
  getStoreImagesState,
  (images) => images.data
);
export const getStoreImagesHasBeenFetched = createSelector(
  getStoreImagesState,
  (images) => images.fetched
);
export const getStoreImagesError = createSelector(
  getStoreImagesState,
  (images) => images.error
);
export const getStoreImagesSuccess = createSelector(
  getStoreImagesState,
  (images) => images.success
);
